export default "__VITE_ASSET__DQHynuFw__"